import React from 'react';

const Dashboard: React.FC = () => <h1>Contratos</h1>;

export default Dashboard;
